import { Link } from "react-router-dom";

const HowItWorks = () => {

    return (
        <>

            <section className='hearo-wrap hero-inner'>
                <div className='container'>

                    {/* <!--=========Bread Crum!=====================--> */}
                    <div className='bread-crum'>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">How it Works</li>
                            </ol>
                        </nav>

                    </div>
                    {/* <!--=========Bread Crum!=====================--> */}
                </div>

                <div className='container hero-bx padding-top-bot'>
                    {/* <!--exchange part!--> */}



                    <div className='row justify-content-center'>
                        <div className='col-md-7'>

                            <h1 className='hero-title top-title'>How does Kittrow Investments s.r.o. exchange work</h1>

                        </div>


                    </div>
                </div>
                {/* <!--exchange part!--> */}






            </section>



            {/* <!--===================Step Part!======================--> */}

            <section className='container step-main '>

                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}

                    <div className='col-md-6'>
                        <div className='stp-btn'><span>Step 1</span></div>
                        <h2 className='sec-title'>Select crypto and fiat — quick and easy</h2>
                        <p>Start by selecting the cryptocurrency you want to exchange and the fiat currency you want to receive. We support popular pairs and convenient payout options.</p>
                    </div>
                    <div className='col-md-6 last-show'>
                        <div className='img-full'>
                            <img src='assets/images/hwork1.png' alt='' />
                        </div>
                    </div>


                </div>
                {/* <!--============Step box wrapper!==========--> */}

                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}
                    <div className='col-md-6 last-show'>
                        <div className='img-full'>
                            <img src='assets/images/hwork2.png' alt='' />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='stp-btn'><span>Step 2</span></div>
                        <h2 className='sec-title'>Quick signup and identity verification</h2>
                        <p>To ensure security and compliance, we need to know who we're working with. Signup takes just a few minutes, and verification is a one-time process.</p>
                    </div>



                </div>
                {/* <!--============Step box wrapper!==========--> */}


                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}

                    <div className='col-md-6'>
                        <div className='stp-btn'><span>Step 3</span></div>
                        <h2 className='sec-title'>Send crypto to the provided wallet</h2>
                        <p>Once verified, you’ll receive the wallet address. As soon as the funds arrive, we’ll begin processing your request. The entire process usually takes less than 30 minutes. In some cases, slight delays may occur due to network load.</p>
                    </div>
                    <div className='col-md-6'>
                        <div className='img-full'>
                            <img src='assets/images/hwork3.png' alt='' />
                        </div>
                    </div>


                </div>
                {/* <!--============Step box wrapper!==========--> */}

                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}
                    <div className='col-md-6 last-show'>
                        <div className='img-full'>
                            <img src='assets/images/hwork4.png' alt='' />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='stp-btn'><span>Step 4</span></div>
                        <h2 className='sec-title'>Receive your funds via your preferred method</h2>
                        <p>Once we confirm receipt of the crypto, you'll receive your money via the selected method — bank card, account, or e-wallet. Fast and transparent. Your data is protected at every step using advanced encryption. We never share personal information with third parties.</p>
                    </div>



                </div>
                {/* <!--============Step box wrapper!==========--> */}



            </section>







            {/* <!--===================Swap section!=================--> */}

            <section className='container sec-pad-t'>
                <div className='swap-part'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-7 col-md-10'>
                            <div className='kit-logo'><img src='assets/images/logo-bg.png' /></div>
                            <h2>Swap Crypto & Fiat Instantly</h2>
                            <p>Buy crypto with your local currency or convert it back — safely and in seconds. Kittrow Investments s.r.o. makes fiat-to-crypto exchange simple, secure, and lightning-fast. No hidden fees, no hassle.</p>
                            <div className='button-group'>
                                <Link to='/' className='btn lm-btn-blue cus-btn-hover-affect'>Start Exchanging Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <div className='sec-pad-t'></div>
            {/* <!--=============Spacer!===========--> */}

        </>
    );
}

export default HowItWorks;